export const keyAndValueOrNull = ({ key, value, condition }) => {
    if (value === null || value === undefined || condition === false) {
        return null;
    }

    return { [key]: value };
};
